import { SecurityModel } from 'api';
import { BREAKPOINT_PRO_RATA } from 'common/constants/cap-table';
import { BreakpointSeries } from '../types/breakpoint-analysis.models';


/**
 * Replaces the pro rata value with the current own percent value
 * @param series - The series to replace the pro rata value with the current own percent value
 * @param securities - The securities to get the current own percent value from
 * @returns The series with the pro rata value replaced with the current own percent value
 */
const replaceProRata = (series: BreakpointSeries[], securities: SecurityModel[]): BreakpointSeries[] => {
  const currentOwnPercentMap = new Map(securities.map(security => [security.id, security.current_own_percent]));
  return series.map(serie => ({
    ...serie,
    value: Number(serie.value === BREAKPOINT_PRO_RATA ? currentOwnPercentMap.get(serie.id) : serie.value),
  }));
};

export default replaceProRata;
